import EventBus from "@plugins/common/service/eventbus";

const embedComponentEventBus = new EventBus();
export default embedComponentEventBus;
